module.exports = {"offer":"Offer Portal"}